import {
	SAVE_CASES,
	SAVE_CONTACTS,
	SAVE_CARE_MANAGER,
	SET_LOADING_CASES,
	SAVE_ALL_DOCUMENTS,
	SAVE_ALL_MESSAGES,
	MERGE_MANAGER_CONTACT,
	CHANGE_STATUS
} from "../actions/cases";
import { UPDATE_UNREAD_MESSAGES } from "../actions/chatCase/messages";

export const initialState = {
	listCases: [],
	listCareManager: [],
	listCasesWithManager: [],
	listCasesWithContacts: [],
	listContacts: [],
	listDocuments: [],
	listMessages: [],
	messages: [],
	loadingCases: true
};

const cases = (state = initialState, action = {}) => {
	switch (action.type) {
	// Sauvegarde la liste des cas existant dans le state. Cette action est exécutée pour sauvegarder les données
	// provenant d'une requête API via un middleware
	case SAVE_CASES : {
		return {
			...state,
			listCases: action.listCases // correspondant au paramètre de la fonction définit dans les actions creators
		};
	}
	// Sauvegarde des CareManager associé au user
	case SAVE_CARE_MANAGER : {
		// Function pour fusionner deux tableaux en fonction d'un id commun
		const mergeById = (array1, array2) =>
			array1.map(itm => ({
				...array2.find((item) => (item.id === itm.idCareManager) && item),
				...itm
			}));

		const newListCareManager = [
			...state.listCareManager,
			action.careManager
		];
		// Fusion de la liste des cas avec la liste des CareManager. Cela permet d'afficher le nom du
		// CareManager associé au cas sur la page Home (Cela peut forcément être optimisable, peut être même
		// côté backend avec une requête qui renvoie les données différemment
		const listCasesWithManager = mergeById(state.listCases, newListCareManager);

		return {
			...state,
			listCareManager: newListCareManager,
			listCasesWithManager : listCasesWithManager,
		};
	}
	case MERGE_MANAGER_CONTACT : {
		// Fonction pour merger les trois arrays et ainsi avoir les contacts et les caremanager d'un cas dans un seul array
		const mergeByIdWithContact = (array1, array2, array3) =>
			array1.map(itm => ({
				...array2.find((item) => (item.id === itm.idCareManager) && item),
				...array3.find((it) => (it.idCase === itm.id) && it),
				...itm
			}));
		// Ne pas hésiter à console.log(state.listCases, state.listCareManager, state.listContacts) et console.log(listCasesWithContacts)
		const listCasesWithContacts = mergeByIdWithContact(state.listCases, state.listCareManager, state.listContacts);
		return {
			...state,
			listCasesWithContacts: listCasesWithContacts
		};
	}
	// Sauvegarde la liste des contacts du user
	case SAVE_CONTACTS : {
		const newListContacts = [
			...state.listContacts,
			action.listContacts,
		];
		return {
			...state,
			listContacts: newListContacts,
		};
	}
	// Sauvegarde de tous les documents liés à l'utilisateur
	case SAVE_ALL_DOCUMENTS : {
		const newDocumentList = [
			...state.listDocuments,
			action.allDocuments
		];
		return {
			...state,
			listDocuments: newDocumentList.flat() // flat permet "d'aplatir" un tableau imbriqué avec plusieurs niveaux
			// https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/Array/flat
		};
	}
	// Sauvegarde TOUS les messages liés à User
	case SAVE_ALL_MESSAGES : {
		const newMessagesList = [
			...state.listMessages,
			action.allMessages
		];
		return {
			...state,
			listMessages: newMessagesList.flat(), // Aplati le tableau d'un niveau d'imbrication
		};
	}
	case SET_LOADING_CASES : {
		return {
			...state,
			loadingCases : action.bool
		};
	}
	// Change le status du PAP. Le status du PAP se trouve dans l'objet listCasesWithManager
	case CHANGE_STATUS : {
		// On cible le cas en question grâce à l'argument passé dans la fonction changeStatut()
		const selectedCase = state.listCasesWithManager.filter((i) => i.id == action.idCase);

		// Nouvel objet qui contient le cas filré precèdement. Le cas se trouvera toujours à l'index 0 étant donnée qu'il
		// ne peut y en avoir qu'un
		const newObj = {
			...selectedCase[0],
			"state" : action.status, // status passé en argument de la fonction changeStatus()
		};
		// on retourne la nouvelle liste avec le cas dont le status a changé ainsi que les autres s'il en existe
		const newListCasesWithManager = [
			...state.listCasesWithManager.filter((i) => i.id !== action.idCase),
			newObj
		];
		return {
			...state,
			listCasesWithManager: newListCasesWithManager
		};
	}
	// Pour mettre à jour le status des messages (non lu -> lu)
	case UPDATE_UNREAD_MESSAGES : {
		// On filtre les messages en fonction de l'idCase passé en argument de la fonction
		const updatedMessagesList = state.listMessages.map((mess) => {
			if (mess.idCase === action.idCase) {
				if (mess.status == 0) {
					return { ...mess, status : 1 };
				}
			}
			return mess;
		});
		return {
			...state,
			listMessages: updatedMessagesList
		};
	}
	default:
		return state;
	}
};

export default cases;